import { useCurrentUser } from "@accurx/auth";
import { useAllAssignees } from "@accurx/concierge/hooks/data/useAllAssignees";
import { useAllUsers } from "@accurx/concierge/hooks/data/useAllUsers";
import { useUser } from "@accurx/concierge/hooks/data/useUser";
import { Conversation } from "@accurx/concierge/types";
import {
    ConversationActions,
    ReadOnlyAssigneeBadge,
} from "domains/inbox/components/ConversationView/components";
import { useIsCollaborativeInboxEnabled } from "domains/inbox/hooks/util/useIsCollaborativeInboxEnabled";

type AssigneeSelectorButtonProps = {
    conversation: Conversation;
};

export const AssigneeSelectorButton = ({
    conversation,
}: AssigneeSelectorButtonProps) => {
    const { user: currentUser } = useCurrentUser();
    const currentUserSummary = useUser({ userId: currentUser.accuRxUserId });
    const isCurrentUserApproved = currentUserSummary?.status === "Approved";
    const isCollaborativeInboxEnabled = useIsCollaborativeInboxEnabled();

    const allUsers = useAllUsers();
    const allAssignees = useAllAssignees();
    const teams = allAssignees.teams
        .filter((team) => team.type !== "ToAssignClinicianMessaging")
        .filter((t) => t.canBeAssignedTo);

    return (
        <>
            {isCollaborativeInboxEnabled && isCurrentUserApproved ? (
                <ConversationActions.Item $collapsible>
                    <ConversationActions.Assign
                        conversation={conversation}
                        users={allUsers}
                        teams={teams}
                    />
                </ConversationActions.Item>
            ) : (
                <ConversationActions.Item $collapsible>
                    <ReadOnlyAssigneeBadge assignee={conversation.assignee} />
                </ConversationActions.Item>
            )}
        </>
    );
};
